import '@styles/pages/seller-page-space.scss';

import { initCarousel } from '@organisms/carousel';
import { initStaticGoogleMap } from '@organisms/static-google-map';
import { initGallery } from '@organisms/gallery';
import { initVirtualvisit } from './seller-page-space/virtual-visit';
import { initSpaceDetails } from './seller-page-space/space-details';

initCarousel();
initSpaceDetails();
initStaticGoogleMap();
initVirtualvisit();
initGallery();
